/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table } from '@/common/base/table';
import { Column } from '@/common/base/table/types';
import { Button } from '@leadsnavi/ui-kit';

// Table 组件示例数据
const tableData = [
  { id: 1, name: 'John Doe', email: 'john@example.com', age: 30, status: 'Active' },
  { id: 2, name: 'Jane Smith', email: 'jane@example.com', age: 25, status: 'Inactive' },
  { id: 3, name: 'Bob Johnson', email: 'bob@example.com', age: 35, status: 'Active' },
  { id: 4, name: 'Alice Brown', email: 'alice@example.com', age: 28, status: 'Active' },
  { id: 5, name: 'Charlie Davis', email: 'charlie@example.com', age: 40, status: 'Inactive' },
  { id: 6, name: 'David Wilson', email: 'david@example.com', age: 32, status: 'Active' },
  { id: 7, name: 'Eve Taylor', email: 'eve@example.com', age: 27, status: 'Active' },
  { id: 8, name: 'Frank Miller', email: 'frank@example.com', age: 38, status: 'Inactive' },
  { id: 9, name: 'Grace Lee', email: 'grace@example.com', age: 31, status: 'Active' },
  { id: 10, name: 'Henry Clark', email: 'henry@example.com', age: 36, status: 'Active' },
];

// Table 组件列配置
const tableColumns: Array<Column<any>> = [
  {
    key: 'name',
    title: 'Name',
    dataIndex: 'name',
    width: 150,
  },
  {
    key: 'email',
    title: 'Email',
    dataIndex: 'email',
  },
  {
    key: 'age',
    title: 'Age',
    dataIndex: 'age',
    width: 100,
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    width: 120,
    render: (status: string) => (
      <span
        className={`px-2 py-1 rounded-full text-xs ${status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
      >
        {status}
      </span>
    ),
  },
  {
    key: 'actions',
    title: 'Actions',
    width: 150,
    render: () => (
      <Button size="sm" className="text-blue-600 hover:text-blue-800">
        Edit
      </Button>
    ),
  },
];

export const TableDemo = () => {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-bold mb-4">Table Component Demo</h2>

      <div className="mb-6">
        <h3 className="text-lg font-semibold mb-2">Basic Table</h3>
        <Table
          data={tableData}
          columns={tableColumns}
          onRowClick={row => console.log('Row clicked:', row)}
          height={400}
          onRowExtraRender={() => {
            return <div>123213</div>;
          }}
        />
      </div>
    </div>
  );
};
